<template>
    <div class="c-statistic-wapper">
        <div class="statistic-list">
            <div class="c-statistic-item">
                <div class="item-text is-bigger">
                    <span class="text-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#gvfont-statistic01"></use>
                        </svg>
                    </span>
                    <p class="text-space">{{ $t("main:30亿") }}</p>
                </div>
                <div class="item-text">
                    <p class="text-space">{{ $t("main:全球用户日均通话时长分钟数") }}</p>
                </div>
            </div>
        </div>
        <div class="statistic-list">
            <div class="c-statistic-item">
                <div class="item-text is-bigger">
                    <span class="text-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#gvfont-statistic02"></use>
                        </svg>
                    </span>
                    <p class="text-space">{{ $t("main:3亿") }}</p>
                </div>
                <div class="item-text">
                    <p class="text-space">{{ $t("main:全球日均活跃用户数量") }}</p>
                </div>
            </div>
        </div>
        <div class="statistic-list">
            <div class="c-statistic-item">
                <div class="item-text is-bigger">
                    <span class="text-icon">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#gvfont-statistic03"></use>
                        </svg>
                    </span>
                    <p class="text-space">{{ $t("main:2000+") }}</p>
                </div>
                <div class="item-text">
                    <p class="text-space">{{ $t("main:累计服务产品数量") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BannerStatistic",
};
</script>

<style scoped lang="less">
.c-statistic-wapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 180px;
    border-top: 1px solid rgba(190, 199, 255, 0.3);
}
.c-statistic-item {
    margin-top: -8px;
    .item-text {
        display: flex;
        align-items: flex-end;
        &.is-bigger {
            .text-space {
                font-size: 38px;
                color: #fff;
            }
        }
        & + .item-text {
            margin-top: 8px;
        }
        .text-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 6px;
            & + .text-space {
                margin-left: 10px;
            }
            .icon {
                width: 30px;
                height: 30px;
            }
        }
        .text-space {
            font-size: 18px;
            letter-spacing: 0.8px;
            color: #8e919a;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-statistic-wapper {
        min-height: 136px;
        .item-text {
            align-items: center;
            &.is-bigger {
                .text-space {
                    font-size: 24px;
                }
            }
            .text-icon {
                padding: 0;
            }
            .text-space {
                font-size: 14px;
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-statistic-wapper {
        min-height: 96px;
        .item-text {
            &.is-bigger {
                .text-space {
                    font-size: 18px;
                }
            }
            .text-space {
                font-size: 12px;
            }
            .text-icon {
                .icon {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }
}
@media only screen and (max-width: 480px) {
    .c-statistic-wapper {
        flex-wrap: wrap;
        align-items: flex-start;
        min-height: 96px;
        padding-top: 16px;
        margin: -12px;
        .statistic-list {
            width: 50%;
            padding: 12px;
        }
        .item-text {
            & + .item-text {
                margin-top: 4px;
            }
            &.is-bigger {
                .text-space {
                    font-size: 16px;
                }
            }
            .text-space {
                letter-spacing: -0.1px;
            }
        }
    }
}
</style>
